// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";

const firebaseConfig = {
  apiKey: "AIzaSyA9t_quso4cOLOrBjG741lSafSMqrKeKSo",
  authDomain: "react-register-16efd.firebaseapp.com",
  projectId: "react-register-16efd",
  storageBucket: "react-register-16efd.appspot.com",
  messagingSenderId: "511339885205",
  appId: "1:511339885205:web:8a9f5a0bfaf5005133a19c",
  measurementId: "G-9EJBM3DBLL"
};


export const app = initializeApp(firebaseConfig);
